import Utils from 'common/scripts/utils';

class DropdownMenu {
    constructor() {
        this.desktopBtn = document.querySelector('.j-open-nav-desctop');
        this.mobileBtn = document.querySelector('.j-open-nav-mobile');
        this.links = [...document.querySelectorAll('.j-dropdown-link')];
        this.overlay = document.querySelector('.j-navigation-overlay');
        this.navigation = document.querySelector('.j-navigation-choose');
        this.isOpened = false;
    }

    /**
     * Метод инициализирует модуль
     */
    init() {
        this._bindEvents();
    }

    /**
     * Метод навешивает обработчики на элементы
     * @private
     */
    _bindEvents() {
        if (this.desktopBtn) {
            document.addEventListener('click', (evt) => {
                if (evt.target.classList.contains('j-dropdown-link') ||
                    evt.target.parentElement.classList.contains('j-dropdown-link')) {
                    return;
                }

                if (this.isOpened) {
                    this._close(this.links);
                } else if (evt.target.classList.contains('j-open-nav-desctop') ||
                        evt.target.parentElement.classList.contains('j-open-nav-desctop')) {
                    this._open(this.links);
                }
            });
        }

        if (this.mobileBtn) {
            this.mobileBtn.addEventListener('click', () => {
                this.navigation.classList.toggle('is-open');
                this.mobileBtn.classList.toggle('is-open');

                return this.navigation.classList.contains('is-open') ?
                    Utils.bodyFixed(this.navigation) :
                    Utils.bodyStatic();
            });
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', () => {
                this.navigation.classList.remove('is-open');
                this.mobileBtn.classList.remove('is-open');
                Utils.bodyStatic();
            });
        }
    }

    /**
     * Метод показывает кнопки
     * @private
     */
    _open([...items]) {
        if (items.length) {
            items.forEach((item) => {
                if (item) {
                    item.classList.add('is-active');
                }
            });
        }

        this.isOpened = true;
    }

    /**
     * Метод скрывает кнопки
     * @private
     */
    _close([...items]) {
        if (items.length) {
            items.forEach((item) => {
                if (item) {
                    item.classList.remove('is-active');
                }
            });
        }

        this.isOpened = false;
    }
}

export default DropdownMenu;
